import classNames from 'classnames';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { compose, defaultProps, setPropTypes, withStateHandlers } from 'recompose';
import { FormGroup, Icon } from '.';

/**
 * Global variable to allow clearing of the currently active typeahead field
 * when the search text is reset to ''.  Used to avoid infinite recursion. 
 */
let canClear = false;

const TypeaheadField = (props) => {

  return (
    <FormGroup validation={props.validation}>
      <div className={classNames('form-item', 'text-item', 'search-item', 'autocomplete', { 'no-icon': !props.icon }, { 'no-margin': props.noMargin })}>
        <AsyncTypeahead
          {...{
            ...props,
            className: classNames({
              focus: props.focused,
              filled: props.searchText
            }, props.className),
            ref: (ref) => {
              if (ref && props.searchText === '' && canClear) {
                canClear = false;
                ref.getInstance().clear();
              }
            },
            emptyLabel: props.isLoading === true ?
              'Searching...' : props.emptyLabel !== undefined ?
              props.emptyLabel : 'No matches',
            onChange: (selected) => {
              props.onChange(selected)
              if (selected.length) {
                canClear = true;
              }
            }
          }}
        />
        <label>{props.label}</label>
        {props.icon ? <Icon icon={props.icon} /> : null}
      </div>
    </FormGroup>
  )
}

export default compose(
  setPropTypes({
    emptyLabel: PropTypes.string,
    filterBy: PropTypes.func,
    isLoading: PropTypes.bool,
    labelKey: PropTypes.func,
    minLength: PropTypes.number,
    multiple: PropTypes.bool,
    onChange: PropTypes.func,
    onInputChange: PropTypes.func,
    onSearch: PropTypes.func,
    options: PropTypes.array,
    renderMenuItemChildren: PropTypes.func,
    searchText: PropTypes.string,
    selected: PropTypes.array,
    useCache: PropTypes.bool,
    label: PropTypes.string,
    icon: PropTypes.string,
    validation: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  }),
  defaultProps({
    filterBy: fp.stubTrue,
    minLength: 3,
    multiple: false,
    useCache: false
  }),
  withStateHandlers(
    {
      focused: false
    },
    {
      onFocus: () => () => ({
        focused: true
      }),
      onBlur: () => () => ({
        focused: false
      })
    }
  )
)(TypeaheadField);



// WEBPACK FOOTER //
// ./src/containers/components/typeahead-field.js